import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import NoImageDefault from "../../../../images/noImage.svg";
import ModuleNoImage from "../../../../images/noImage/module.svg";
import CompetenceNoImage from "../../../../images/noImage/competence.svg";
import ProgrammsNoImage from "../../../../images/noImage/programms.svg";
import imageBoxFont from "../../../../images/imageBoxFont.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: props => !props.image && 160,
    border: props => !props.image && "1px dashed #CACCD1",
    backgroundImage: props =>
      props.type && !props.image && `url(${imageBoxFont})`,
    backgroundColor: props => !props.type && "#E9ECF7",
    padding: props => !props.image && "15px 25px"
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: props => (props.image ? 239 : 110),
    height: props => (props.image ? 160 : 90),

    overflow: "hidden",
    // height: props => !props.image && 90,
    // width: props => !props.image && 110,
    opacity: props => !props.image && "70%",
    border: props => props.type && !props.image && "2px dashed #CACCD1",
    backgroundColor: props => props.type && "#fff",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: props => props.image && "cover"
    }
  }
});

const ImageBox = props => {
  const { image, type } = props;
  const classes = useStyles(props);
  const baseURL = "/work/api/file";

  let noImage;
  if (type === "module") {
    noImage = ModuleNoImage;
  } else if (type === "competence") {
    noImage = CompetenceNoImage;
  } else if (type === "programs") {
    noImage = ProgrammsNoImage;
  } else {
    noImage = NoImageDefault;
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {image ? (
          <img src={`${baseURL}/${image}`} alt={type} />
        ) : (
          <img src={noImage} alt="Нет изображения" />
        )}
      </div>
    </div>
  );
};

export default ImageBox;
